/*
  BugBell: Versandkosten nach DE im Warenkorb
  Ersetzt den Platzhalter "Wird berechnet …" aus snippets/totals-cart.liquid durch die
  Versandkosten aus Shopifys Cart Shipping Rates.
  Vorher stand dieses Skript inline in sections/mini-cart.liquid und lief deshalb nicht
  auf der Warenkorbseite /cart (dort wird der Mini-Cart nicht gerendert).
  Geladen in layout/theme.liquid, damit es im Drawer und auf /cart läuft.
*/
(() => {
  if (window.bugbellGermanCartShipping) return;
  window.bugbellGermanCartShipping = true;

  const totalsSelector = '.totals[data-bb-de-shipping]';
  // Nur die Leiste im ausklappenden Warenkorb; die Leiste auf /cart rechnet Liquid serverseitig.
  const noteSelector = 'free-shipping-bar[data-bb-shipping-note]';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartRoot = root.replace(/\/?$/, '/');
  // Einheitlicher deutscher Beispielort; bei PLZ-abhängigen Tarifen ist dies ein Richtwert.
  const address = new URLSearchParams({
    'shipping_address[country]': 'Germany',
    'shipping_address[zip]': '10115'
  });
  let generation = 0;
  let timer;

  function money(cents, currency) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency || 'EUR'
    }).format(cents / 100);
  }

  function notes(cart, shippingCents) {
    document.querySelectorAll(noteSelector).forEach((note) => {
      const label = note.querySelector('.shipping-bar__text');
      if (!cart || cart.item_count === 0 || !cart.requires_shipping) {
        note.hidden = true;
        return;
      }
      note.hidden = false;
      const threshold = Number(note.getAttribute('threshold'));
      const physicalTotal = Array.isArray(cart.items)
        ? cart.items.reduce((sum, item) => sum + (item.requires_shipping ? item.final_line_price : 0), 0)
        : cart.total_price;
      const progress = shippingCents === 0 ? 1 : threshold > 0
        ? Math.min(physicalTotal / threshold, 1) : 0;
      note.style.setProperty('--progress', String(progress));
      if (!label) return;
      if (shippingCents === 0) {
        label.textContent = 'Kostenloser Versand nach DE';
      } else if (!Number.isFinite(shippingCents)) {
        label.textContent = 'Versandkosten werden an der Kasse berechnet';
      } else if (threshold > 0 && physicalTotal < threshold) {
        label.textContent = 'Dir fehlen noch ' + money(threshold - physicalTotal, cart.currency) +
          ' bis zum kostenlosen Versand.';
      } else {
        label.textContent = 'Versand nach DE: ' + money(shippingCents, cart.currency);
      }
    });
  }

  function pending() {
    document.querySelectorAll(totalsSelector).forEach((totals) => {
      if (totals.dataset.bbRequiresShipping !== 'true') return;
      totals.querySelector('.totals__subtotal-value-price').textContent = 'Wird berechnet …';
      totals.querySelector('.total-value-price').textContent = 'Wird berechnet …';
    });
    document.querySelectorAll(noteSelector).forEach((note) => {
      const label = note.querySelector('.shipping-bar__text');
      if (label) label.textContent = 'Versand nach DE wird berechnet …';
      note.hidden = false;
    });
  }

  function render(cart, shippingCents) {
    const subtotal = Number(cart.total_price);
    const formattedSubtotal = money(subtotal, cart.currency);
    const known = Number.isFinite(shippingCents);
    const shippingText = !cart.requires_shipping || shippingCents === 0
      ? 'Kostenlos'
      : known ? money(shippingCents, cart.currency) : 'An der Kasse';
    document.querySelectorAll(totalsSelector).forEach((totals) => {
      const subtotalValue = totals.querySelector('.totals-row .totals__subtotal-value');
      if (subtotalValue) subtotalValue.textContent = formattedSubtotal;
      const delivery = totals.querySelector('.totals__subtotal-value-price');
      if (delivery) {
        delivery.textContent = shippingText;
        delivery.classList.toggle('free-shipping-label', shippingText === 'Kostenlos');
      }
      const total = totals.querySelector('.total-value-price');
      if (total) total.textContent = known || !cart.requires_shipping
        ? money(subtotal + (cart.requires_shipping ? shippingCents : 0), cart.currency)
        : 'An der Kasse';
    });

    notes(cart, shippingCents);
  }

  async function json(url, options) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error('Shopify-Versandtarife nicht verfügbar');
    return response.json();
  }

  async function shippingRate() {
    const query = '?' + address.toString();
    await json(cartRoot + 'cart/prepare_shipping_rates.json' + query, { method: 'POST' });
    for (let attempt = 0; attempt < 10; attempt++) {
      if (attempt) await new Promise((resolve) => setTimeout(resolve, 400));
      const result = await json(cartRoot + 'cart/async_shipping_rates.json' + query);
      if (result === null) continue;
      if (!Array.isArray(result.shipping_rates) || !result.shipping_rates.length) {
        throw new Error('Keine Versandtarife für Deutschland');
      }
      const prices = result.shipping_rates
        .map((rate) => Math.round(Number(rate.price) * 100))
        .filter((price) => Number.isFinite(price) && price >= 0);
      if (!prices.length) throw new Error('Ungültige Versandtarife');
      return Math.min(...prices);
    }
    throw new Error('Versandtarife noch nicht bereit');
  }

  async function refresh() {
    const current = ++generation;
    if (!document.querySelector(totalsSelector)) return;
    try {
      const cart = await json(cartRoot + 'cart.js', { cache: 'no-store' });
      if (current !== generation) return;
      if (!cart.requires_shipping || cart.item_count === 0) {
        render(cart, 0);
        return;
      }
      const rate = await shippingRate();
      if (current === generation) render(cart, rate);
    } catch (error) {
      if (current !== generation) return;
      try {
        const cart = await json(cartRoot + 'cart.js', { cache: 'no-store' });
        if (current === generation) render(cart, null);
      } catch (_) {
        document.querySelectorAll(totalsSelector).forEach((totals) => {
          totals.querySelector('.totals__subtotal-value-price').textContent = 'An der Kasse';
          totals.querySelector('.total-value-price').textContent = 'An der Kasse';
        });
      }
    }
  }

  function schedule() {
    generation++;
    clearTimeout(timer);
    pending();
    timer = setTimeout(refresh, 150);
  }

  function init() {
    schedule();
    new MutationObserver((records) => {
      if (records.some(({ addedNodes }) => [...addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches?.(totalsSelector) || node.querySelector?.(totalsSelector))
      ))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
